import styled from "styled-components";

import { IconSet } from "utils/constants";

interface Props {
  data: any;
}

const Facilities = ({ data }: Props) => {
  return (
    <IconContainer>
      {data.map((facility: string, index: number) => (
        <IconItem key={index}>
          <StyledIcon src={IconSet[facility].icon} />
          <IconText>{IconSet[facility].title}</IconText>
        </IconItem>
      ))}
    </IconContainer>
  );
};

const IconContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0px, 1fr));
  margin-top: 32px;
`;

const IconItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`;

const IconText = styled.span`
  color: #222222;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`;

const StyledIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 10px;
`;

export default Facilities;
